<script>
import loginType from '@/constant/loginType'
import { urls } from '@/constant/paths'
import { jump } from '@/mixins/pageJump/'

const urlConfig = {
    owfUrl: '/mobile/cn/sc/login',
    cxUrl: `${urls.MP_CHECK_TICKET}?type=${loginType.WX_QUERY}`
}

export default {
    beforeMount() {
        jump(urlConfig)
        this.$store.commit('setShowHeader', false) // 隐藏公共的头部
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/waybill/index.vue